import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport } from "vue";
const _hoisted_1 = ["aria-description"];
const _hoisted_2 = {
  class: "displayed-language"
};
const _hoisted_3 = {
  class: "cmp--header_language-selector-placeholder"
};
const _hoisted_4 = {
  class: "cmp--header_language-heading"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "cmp--header_language-modal_separator"
}, null, -1);
const _hoisted_7 = ["href", "target"];
const _hoisted_8 = {
  class: "cmp-mega-menu-navigation-language-selector"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_GlobeIcon = _resolveComponent("GlobeIcon");
  const _component_ArrowSmall = _resolveComponent("ArrowSmall");
  const _component_Arrow = _resolveComponent("Arrow");
  const _component_LoadingDots = _resolveComponent("LoadingDots");
  const _component_HumanMachineLanguage = _resolveComponent("HumanMachineLanguage");
  return _openBlock(), _createElementBlock(_Fragment, null, [(_openBlock(), _createBlock(_Teleport, {
    to: $options.teleportID
  }, [_createElementVNode("button", {
    class: "displayed-language-container",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.toggleLanguageModal && $options.toggleLanguageModal(...args)),
    type: "button"
  }, [_createVNode(_component_GlobeIcon), _createElementVNode("span", {
    "aria-label": "Language",
    "aria-description": $options.currentLang
  }, [_createElementVNode("p", _hoisted_2, _toDisplayString($options.currentLang), 1)], 8, _hoisted_1), _createElementVNode("span", _hoisted_3, "(" + _toDisplayString($options.getLabel('change.Title')) + ")", 1), _withDirectives(_createVNode(_component_ArrowSmall, null, null, 512), [[_vShow, !$data.mobileAndTabletCheck]])]), _withDirectives(_createElementVNode("div", {
    class: _normalizeClass(["cmp--header_language-modal", {
      'cmp--header_language-modal--open': $options.showModal && $data.mobileAndTabletCheck && !$options.humanMachineFlag
    }])
  }, [_withDirectives(_createElementVNode("button", {
    class: "cmp-header__back",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.toggleLanguageModal && $options.toggleLanguageModal(...args))
  }, [_createVNode(_component_ArrowSmall), _createTextVNode(" " + _toDisplayString($options.getLabel('button.back.UPPER')), 1)], 512), [[_vShow, $data.mobileAndTabletCheck]]), _createElementVNode("p", _hoisted_4, _toDisplayString($options.getLabel('Language')), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.languageKeys, (key, index) => {
    return _openBlock(), _createElementBlock("a", {
      href: "#",
      class: "cmp--header_language-modal_option",
      key: key,
      onClick: $event => $options.switchLanguage(key, $options.languages[key].pageLink)
    }, [_createTextVNode(_toDisplayString($options.languages[key].displayLanguage) + " ", 1), _createVNode(_component_Arrow)], 8, _hoisted_5);
  }), 128)), _hoisted_6, _createElementVNode("a", {
    href: $options.linkURL,
    target: $options.linkURL || '_self',
    class: "cmp--header_language-modal_option"
  }, [_createTextVNode(_toDisplayString($options.getLabel('locationtext.title')) + " ", 1), _createVNode(_component_Arrow)], 8, _hoisted_7)], 2), [[_vShow, $options.showModal && !$options.humanMachineFlag]]), $data.isChangingLang ? (_openBlock(), _createBlock(_component_LoadingDots, {
    key: 0,
    class: "change-lang-loading",
    loading: $data.isChangingLang
  }, null, 8, ["loading"])) : _createCommentVNode("", true)], 8, ["to"])), (_openBlock(), _createBlock(_Teleport, {
    to: $options.teleportTarget
  }, [_withDirectives(_createElementVNode("div", _hoisted_8, [_createVNode(_component_HumanMachineLanguage, {
    languageList: $options.languages,
    machineLanguageList: $options.machineLanguages,
    mobileAndTabletCheck: $data.mobileAndTabletCheck,
    tagDescription: $options.tagDescription
  }, null, 8, ["languageList", "machineLanguageList", "mobileAndTabletCheck", "tagDescription"])], 512), [[_vShow, $options.showModal && $options.humanMachineFlag]])], 8, ["to"]))], 64);
}